// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__Ya4J1","content":"styles_content__1F61I","checkbox":"styles_checkbox__2pQZ1","checkboxLabel":"styles_checkboxLabel___O5qd"};